<template>
	<section>
		<h2 class="onboarding-title">Daily Goals</h2>
		<p class="onboarding-text lead">
			Set a daily calorie ceiling to stay on track. Leave it blank if you don't
			want a limit.
		</p>
		<div class="form-group">
			<label class="form-label" for="onboarding-max-calories"
				>Max daily calories</label
			>
			<input
				id="onboarding-max-calories"
				type="number"
				min="0"
				class="form-control"
				placeholder="Blank = not restricted"
				v-model="model" />
		</div>
	</section>
</template>

<script setup>
	import { computed } from "vue"

	const props = defineProps({
		modelValue: {
			type: String,
			default: "",
		},
	})

	const emit = defineEmits(["update:modelValue"])

	const model = computed({
		get: () => props.modelValue ?? "",
		set: (value) => emit("update:modelValue", value),
	})
</script>

<style scoped>
	.form-group {
		margin-bottom: 1rem;
	}
</style>
